import React from 'react'
import { Button, Space, Tooltip, message } from 'antd'
import { useDispatch } from 'react-redux'
import { setLanguage } from '../../store/Language/LanguageSlice'
import useTranslation from '../../localization/useTranslation'
import http from '../../store/services/http-common'

const LanguageToggler = ({ size = 'small', variant = 'buttons' }) => {
  const dispatch = useDispatch()
  const { t, language } = useTranslation()

  const setLang = async (lang) => {
    // Update client-side language and document direction
    dispatch(setLanguage(lang))

    // Try to persist language on server for authenticated users
    try {
      console.debug('[LanguageToggler] sending locale update to server', (lang || 'en').toUpperCase());
      const res = await http.post('/api/vendor/locale', { locale: (lang || 'en').toUpperCase() })
      if (res?.data?.message) {
        message.success(res.data.message)
      } else {
        // fallback localized message
        message.success(t('responses.common.locale_updated'))
      }
    } catch (e) {
      // If unauthenticated or server error, surface any localized message if present
      const msg = e?.response?.data?.message
      if (msg) {
        message.error(msg)
      } else {
        // don't spam errors for unauthenticated users
        console.debug('[LanguageToggler] locale update request failed', e?.response?.status ?? e?.message)
      }
    }
  }

  // single round toggle used in navbar-like places
  if (variant === 'round') {
    const next = language === 'ar' ? 'en' : 'ar'
    return (
      <Tooltip
        getPopupContainer={() => document.body}
        placement="bottomRight"
        overlayStyle={{ whiteSpace: 'nowrap' }}
        title={language === 'ar' ? t('ui.switch_to_en', 'Switch to English') : t('ui.switch_to_ar', 'Switch to Arabic')}
      >
        <Button
          size={size}
          type="default"
          shape="round"
          style={{ minWidth: 44, boxSizing: 'border-box' }}
          onClick={() => setLang(next)}
        >
          {language === 'ar' ? t('ui.lang_en_short','EN') : t('ui.lang_ar_short','ع')}
        </Button>
      </Tooltip>
    )
  }

  return (
    <Space>
      <Tooltip getPopupContainer={() => document.body} placement="bottom" overlayStyle={{ whiteSpace: 'nowrap' }} title={t('ui.switch_to_en', 'Switch to English')}>
        <Button size={size} type={language === 'en' ? 'primary' : 'default'} style={{ minWidth: 44, boxSizing: 'border-box' }} onClick={() => setLang('en')}>
          {t('ui.lang_en_short','EN')}
        </Button>
      </Tooltip>

      <Tooltip getPopupContainer={() => document.body} placement="bottom" overlayStyle={{ whiteSpace: 'nowrap' }} title={t('ui.switch_to_ar', 'Switch to Arabic')}>
        <Button size={size} type={language === 'ar' ? 'primary' : 'default'} style={{ minWidth: 44, boxSizing: 'border-box' }} onClick={() => setLang('ar')}>
          {t('ui.lang_ar_short','ع')}
        </Button>
      </Tooltip>
    </Space>
  )
}

export default LanguageToggler
